import { templateStatusLabelKey } from 'intl/helpers/inspection/templateStatusLabelKey';
import { Translate } from 'intl/translate';
import { InspectionTemplateStatus } from 'shared/domain/template/templateStatus';

export function statusToLabel(
  translate: Translate,
  status: InspectionTemplateStatus
): string {
  return translate(templateStatusLabelKey(status));
}
